export const PLATFORM_AUTHENTICATOR_AAGUIDS = {
  WINDOWS_HELLO_V1: '08987058-cadc-4b81-b6e1-30de50dcbe96',
  WINDOWS_HELLO_V2: '9ddd1817-af5a-4672-a2b9-3e3dd95000a9',
  WINDOWS_HELLO_V3: '6028b017-b1d4-4c02-b4b3-afcdafc96bb2',
  CHROME_ON_MAC: 'adce0002-35bc-c60a-648b-0b25f1f05503',
  EDGE_ON_MAC: '771b48fd-d3d4-4f74-9232-fc157ab0507a',
  CHROMIUM_BROWSER: 'b5397666-4885-aa6b-cebf-e52262a439a2',
  ANDROID_SAFETYNET: 'b93fd961-f2e6-462f-b122-82002247de78',
} as const;

export const PLATFORM_AAGUIDS = new Set<string>(
  Object.values(PLATFORM_AUTHENTICATOR_AAGUIDS)
);
